// extracted by mini-css-extract-plugin
module.exports = {"rating":"BrowseResultRating-module--rating--59f4c5","label":"BrowseResultRating-module--label--75ecaf"};